const TRACK_HEIGHT = 8;
const PERCENT_MAX = 100;
const MIN_VISIBLE_FILL = 4;

export const meterStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.75,
  minWidth: 200,
};

export const labelRowStyles = ({ palette }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 1,
  color: palette.text.secondary,
  fontVariantNumeric: 'tabular-nums',
});

export const trackStyles = ({ palette }) => ({
  height: TRACK_HEIGHT,
  borderRadius: 999,
  overflow: 'hidden',
  backgroundColor: palette.action.hover,
});

export const getFillStyles =
  ({ ratio, fillPalette }) =>
  ({ palette }) => ({
    height: '100%',
    borderRadius: 999,
    width: `${Math.round(ratio * PERCENT_MAX)}%`,
    minWidth: ratio > 0 ? MIN_VISIBLE_FILL : 0,
    backgroundColor: fillPalette ? palette[fillPalette].main : palette.text.disabled,
    transition: 'width 240ms ease',
  });
